import React from 'react';
import { withTranslation } from '../../ChildrenContext.js';
import PropTypes from 'prop-types'
import StatisticsByRefererContentComponent from './StatisticsByRefererContent/StatisticsByRefererContent.container';
import { withRouter } from '../../RouterCompatibility.js';

const StatisticsByRefererPage = ({ location, t }) => {
    const staticNames = t?.reportPage || {};

    return (
        <div className="dashboard dashboard_consolidated-report">
            <div className="page-heading">
                <div className="page-heading__inner">
                    <h2>{staticNames.titleByReferer}</h2>
                </div>
            </div>

            <StatisticsByRefererContentComponent
                location={location}
            />
        </div>
    );
};

StatisticsByRefererPage.propTypes = {
    location: PropTypes.object,
    t: PropTypes.object
};

export default withRouter(withTranslation(StatisticsByRefererPage));